import quickfield from 'quickfield'
import SelectField from 'quickfield/dist/fields/select'
import ChoiceField from 'quickfield/dist/fields/choice'
import TextareaField from 'quickfield/dist/fields/textarea'
import TrueFalseField from 'quickfield/dist/fields/truefalse'
import RepeaterField from 'quickfield/dist/fields/repeater'
import GroupField from 'quickfield/dist/fields/group'
import ImageBase64Field from './image-base64'
import PhotoField from './photo'
import ChoiceColorField from './choice-color'
import ChoiceStyleField from './choice-style'

quickfield.register 'select', SelectField
quickfield.register 'choice', ChoiceField
quickfield.register 'textarea', TextareaField
quickfield.register 'truefalse', TrueFalseField
quickfield.register 'repeater', RepeaterField
quickfield.register 'group', GroupField
quickfield.register 'photo', PhotoField
quickfield.register 'image-base64', ImageBase64Field
quickfield.register 'choice-color', ChoiceColorField
quickfield.register 'choice-style', ChoiceStyleField

export default quickfield.config(
	global:
		fontFamily: 'din'
		fontSize: 14
		distance: 8
		margin: '0 0 20px 0'
	text:
		height: 57
		checkmark: false
	select:
		height: 57
	textarea:
		height: 320
		autoHeight: false

,
	text:
		field: children:
			innerwrap: style:
				borderRadius: 4
				$focus: borderColor: '#fac50a'
			label: style:
				$focus: color: '#fac50a'
	
	select:
		field: children:
			innerwrap: style:
				borderRadius: 4
				$focus: borderColor: '#fac50a'
			label: style:
				$focus: color: '#fac50a'
	
	textarea:
		field: children:
			innerwrap: style:
				borderRadius: 4
				$focus: borderColor: '#fac50a'
			label: style:
				$focus: color: '#fac50a'
	
	choice:
		field: children:
			label: style:
				marginBottom: 15
				fontSize: 14
				color: '#858D94'

		choice:
			options: style:
				color: '#E5E8ED'
				$selected:
					color: '#fac50a'
			
			children:
				border: style:
					borderRadius: 4
				
				label: style:
					padding: '18px 0 15px'
					fontSize: 14
					fontWeight: 600
					color: '#818990'
					$selected:
						color: '#fac50a'
)
